import { Range } from '@attain-apps/range'

import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Total',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'TDC',
                      value: {
                        '{}': {
                          aside: 'goal of 94M (2023)',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'glExpenses',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    94000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Total Direct Cost - All direct expenses charged to a research project.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC',
                      value: {
                        '{}': {
                          aside: 'goal of 66M (2023)',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'glExpenses',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    66000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Average',
                      value: {
                        '{}': {
                          tooltip: '3-Year average of MTDC',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdcInLastThreeYears',
                                    },
                                  },
                                  3,
                                ],
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'ASF',
                      value: {
                        '{}': {
                          aside: 'Sq. Ft.',
                          tooltip: 'ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.001,
                                suffix: 'K',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Density',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'TDC Density',
                      value: {
                        '{}': {
                          tooltip: 'Total TDC / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Density',
                      value: {
                        '{}': {
                          tooltip: 'Total MTDC / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Avg Density',
                      value: {
                        '{}': {
                          aside: 'goal of 250 / ASF',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '@': 'glExpensesInMtdcInLastThreeYears',
                                              },
                                            },
                                            3,
                                          ],
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    250,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip: '3-Year MTDC Average / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '@': 'glExpensesInMtdcInLastThreeYears',
                                        },
                                      },
                                      3,
                                    ],
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Other',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Utilization',
                      value: {
                        '{}': {
                          tooltip:
                            'Percentage of ASF actively used for research.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              {
                                ',': true,
                                '.': {
                                  max: 2,
                                  min: 2,
                                },
                                scalar: 100,
                                suffix: '%',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
  subqueries: {
    rooms: {
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    true,
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'roomOrgShouldAnalyze',
                    },
                    {
                      '[]': [true],
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgSpace: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
        roomOrgShouldAnalyze: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
          },
          using: 'roomOrgSpace',
          target: 'dim::!org',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    glExpenses: {
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@': 'researchType',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!proj',
              },
              null,
            ],
          },
          {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    true,
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'expenseOrgShouldAnalyze',
                    },
                    true,
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        '@$': 'focusedRange',
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '{}': {
          tdcAmount: {
            '@.': '!amount',
          },
          mtdcAmount: {
            if: [
              [
                {
                  '@': 'isInMtdc',
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        isInMtdc: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!is_in_mtdc',
          },
        },
        researchType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@.': '!research_type_wfuhs',
          },
        },
        expenseOrgShouldAnalyze: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@': 'organizationShouldAnalyze',
          },
          subqueries: {
            organizationShouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
      },
    },
    glExpensesInMtdcInLastThreeYears: {
      filter: {
        and: [
          {
            '!=': [
              {
                '@.': '!proj',
              },
              null,
            ],
          },
          {
            '@': 'isInMtdc',
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@': 'researchType',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    true,
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'expenseOrgShouldAnalyze',
                    },
                    true,
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '@.': '!amount',
      },
      subqueries: {
        isInMtdc: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!is_in_mtdc',
          },
        },
        researchType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@.': '!research_type_wfuhs',
          },
        },
        expenseOrgShouldAnalyze: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@': 'organizationShouldAnalyze',
          },
          subqueries: {
            organizationShouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
      },
    },
  },
}
